import { render, staticRenderFns } from "./EditSecureSetting.vue?vue&type=template&id=c0ddb384&"
import script from "./EditSecureSetting.vue?vue&type=script&lang=js&"
export * from "./EditSecureSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports